import { ComponentTypes } from "../../../config/config";
import { IFolderPanelInfo } from "../../../interfaces/IFolderPanelInfo";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { getLastSplittedStringItem } from "../stringHelper";
import { BaseFolderPanelHelper } from "./BaseFolderPanelHelper";
import { IFolderPanelHelper } from "../../../interfaces/IFolderPanelHelper";
import { SharePointFolderContentTypeIds } from "../../../config/constants";

export class SharepointFolderPanelHelper extends BaseFolderPanelHelper implements IFolderPanelHelper {
    constructor(folderPanelInfo: IFolderPanelInfo,
        currentDirectory: IPageSettings,
        private addWorkingDirectory: (location: IPageSettings) => {
            type: "ADD_WORKING_DIRECTORY";
            payload: IPageSettings;
        },
        private languageStrings: any) {
        super(folderPanelInfo, currentDirectory);
    }

    async getFolderFinalLocation(): Promise<IPageSettings> {
        const isRootDirectory = !this.folderPanelInfo.folder.id;
        return {
            ...this.getShareableSharepointProperties(),
            id: isRootDirectory ? this.folderPanelInfo.folder.driveId : this.folderPanelInfo.folder.id,
            parentId: isRootDirectory ? null : this.folderPanelInfo.folder.driveId,
            type: ComponentTypes.SharePointFolders,
            // directory: !this.currentDirectory.directory ? this.folderPanelInfo.folder.name : `${this.currentDirectory.directory}/${this.folderPanelInfo.folder.name}`,
            directory: !this.currentDirectory.directory ? (this.folderPanelInfo.webUrl ? `${getLastSplittedStringItem(this.folderPanelInfo.webUrl, /[\s/]+/)}` : this.folderPanelInfo.folder.name) : `${this.currentDirectory.directory}/${this.folderPanelInfo.folder.name}`,
            // DocumentLibrary: this.currentDirectory.DocumentLibrary,
            DocumentLibrary: this.currentDirectory.DocumentLibrary?.length > 0 ? this.currentDirectory.DocumentLibrary : this.folderPanelInfo.folder.name,
            isTeamsFolder: this.currentDirectory.isTeamsFolder,
            isTeamsRootFolder: false,
            sharePointListId: this.currentDirectory?.sharePointListId ?? this.folderPanelInfo.folder.sharePointListId,
            contentTypeId: this.folderPanelInfo.folder.contentTypeId,
            sharePointUniqueId: !isRootDirectory && this.folderPanelInfo.folder.sharePointUniqueId
        };
    }

    async save() {
        let isRootDirectory = !this.folderPanelInfo.folder.id;
        let itemToAdd: IPageSettings = {
            id: isRootDirectory ? this.folderPanelInfo.folder.driveId : this.folderPanelInfo.folder.id,
            parentId: isRootDirectory ? null : this.folderPanelInfo.folder.driveId,
            type: ComponentTypes.Saving,
            siteId: this.currentDirectory.siteId,
            siteDisplayName: this.currentDirectory.siteDisplayName,
            webUrl: this.currentDirectory.webUrl,
            fileTitle: this.folderPanelInfo.folder.name,
            directory: isRootDirectory
                ? this.folderPanelInfo.webUrl ? `${getLastSplittedStringItem(this.folderPanelInfo.webUrl, /[\s/]+/)}` : this.getRootWebUrl()
                : this.folderPanelInfo?.locations ? `${this.currentDirectory.directory}` : `${this.currentDirectory.directory}/${this.folderPanelInfo.folder.name}`,
            DocumentLibrary: isRootDirectory ? this.folderPanelInfo.folder.name : this.currentDirectory.DocumentLibrary,
            displayName: this.languageStrings.Properties,
            isTeamsFolder: this.currentDirectory.isTeamsFolder,
            sharePointListId: isRootDirectory ? this.folderPanelInfo.folder.sharePointListId : this.currentDirectory.sharePointListId,
            contentTypeId: this.folderPanelInfo.folder.contentTypeId,
            parentDocumentSetContentTypeId: this.folderPanelInfo?.locations?.find(dir => dir?.contentTypeId?.startsWith(SharePointFolderContentTypeIds.documentSet))?.contentTypeId,
            sharePointUniqueId: !isRootDirectory && this.folderPanelInfo.folder.sharePointUniqueId
        };

        this.addWorkingDirectory({...itemToAdd, isSaveLocationStructureSet: true});
    }

    private getRootWebUrl = () => {
        const finalLocation = this.folderPanelInfo.locations[this.folderPanelInfo.locations.length - 1];
        return `${finalLocation.directory}`
    }
}
